module.exports = __webpack_public_path__ + "img/collectFail.cd64fd13.png";